import { defineMessage } from 'services/localization';

export const messages = {
    accountName: defineMessage('billing_subscriptions'),
    accountTitle: defineMessage('manage_subscriptions_and_business_account_details'),
    developerName: defineMessage('developer_portal'),
    developerTitle: defineMessage('sign_up_and_manage_your_our_data_via_public_api'),
    publicApiConnectionsListName: defineMessage('connections_list'),
    publicApiConnectionsListTitle: defineMessage('manage_your_connections_y_rd_party_applications'),
    partnerName: defineMessage('partner_portal'),
    partnerTitle: defineMessage('access_to_certification_and_partneronly_materials'),
    customerFeedbackName: defineMessage('customer_feedback'),
    customerFeedbackTitle: defineMessage('customer_feedback_and_voting_tool'),
    practiceStaffName: defineMessage('practice_staff'),
    practiceStaffTitle: defineMessage('manage_staff_members'),
};
